<template><!-- svgo-optimised -->
<svg class="icon icon__menu" viewBox="0 0 25 24" xmlns="http://www.w3.org/2000/svg"><path d="M5.944 6h13v1.4h-13zM5.944 11.4h13v1.4h-13zM5.944 16.8h13v1.4h-13z" /></svg></template>